import { FEELIX_THEMES } from '../../../constants';

export const getStyleProps = (theme: string) => {
  const shouldUseLargePadding = [
    FEELIX_THEMES.MODERN,
    FEELIX_THEMES.PARTNER,
    FEELIX_THEMES.COMMON
  ].includes(theme);

  return (
    {
      footer: {
        paddingTop: 'clear',
        paddingBottom: 'clear',
        paddingLeft: 'md',
        paddingRight: 'md',
        ...(shouldUseLargePadding && {
          paddingLeft: 'lg',
          paddingRight: 'lg'
        })
      }
    }
  )
};
